import { jwtDecode, JwtDecodeOptions, JwtPayload } from 'jwt-decode';

export class JwtDecodeWrapper {
	static decode(token: string, options?: JwtDecodeOptions): JwtPayload {
		return jwtDecode(token, options);
	}
}
